<template>
  <div class="life-form" :style="{ padding }">
    <div class="life-form-item" v-for="(item, index) in list" :key="item.id">
      <!-- 标题 -->
      <div class="form-item-title">{{item.title}}</div>
      <div class="form-item-value">
        <!-- text -->
        <span v-if="item.type === 'text'" class="text-red">{{item.name}}</span>
        <!-- input -->
        <input v-if="item.type === 'input'" :value="item.value" :placeholder="item.tips"
        :disabled="item.disabled ? true: false" :type="item.inputType ? item.inputType: 'text'"
        @input="handleInput($event, list[index], index, item.isNumber)" />
        <span v-if="item.type === 'select'" class="select-text"
        :class="{ 'select-text-act': item.name }">
        	{{item.name ? item.name: '请选择'}}
        </span>
      </div>
      <!-- select -->
      <div class="form-item-select">
        <el-select v-if="item.type === 'select'" :value="item.value" :placeholder="item.tips"
        clearable :popper-append-to-body="false" @change="selectChange($event, item, index)">
          <el-option v-for="ite in item.list" :key="ite.id" :label="ite.name" :value="ite.id" />
        </el-select>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      value: {
      	type: Object,
      	default: () => {}
      },
      list: {
        type: Array,
        default: () => []
      },
      padding: {
        type: String,
        default: '0 16px'
      }
    },
    watch: {
      list: {
        handler(newVal) {
          this.emitFormVal(newVal)
        },
        deep: true,
        immediate: true
      }
    },
    methods: {
      emitFormVal(list) {
        const copyForm = {}
        list.forEach(item => {
        	copyForm[item.key] = item.value
        })
        this.$emit('update:value', copyForm)
        this.$emit('listChange', this.list)
      },
      handleInput(e, item, index, isNumber) {
        let str = e.target.value

        if (item.inputType) {
          // digit-带小数点数字 integer-数字 text-字符串
          switch(item.inputType) {
            case 'integer':
              str = str.replace(/[^\d]/g, '');
              e.target.value = str
              break;
            case 'digit':
              if (str.indexOf(".") != -1) {
                const str_ = str.substr(str.indexOf(".") + 1);
                if (str_.indexOf(".") != -1) {
                  str = str.substr(0, str.indexOf(".") + str_.indexOf(".") + 1);
                }
              }
              str = str.replace(/[^\d^\.]+/g, '');
              break;
          }
        }

        this.setFormItemValue(item, index, str)
      },
      selectChange(id, item, index) {
      	this.setFormItemValue(item, index, id)
      },
      // 更改某一项值
      setFormItemValue(item, index, val) {
      	const newItem = JSON.parse(JSON.stringify(item))
      	newItem.value = val
        if (item.type === 'select') {
        	const { name } = item.list.find(ite => ite.id === val)
        	newItem.name = name
        }
      	const newList = JSON.parse(JSON.stringify(this.list))
      	newList[index] = newItem
      	this.$emit('update:list', newList)
      	// 立即同步更新 value，确保 watch 能正确触发
      	this.emitFormVal(newList)
      }
    }
  }
</script>

<style lang="less" scoped>

  /deep/ .el-select-dropdown {
    position: absolute !important;
    z-index: 15 !important;
  }

  .life-form {
    width: 100%;

    /deep/ .el-input__inner {
      background-color: transparent;
      text-align: right;
      padding-right: 0;
      font-size: 16px;
    }
    /deep/ .el-input__suffix {
      display: none;
    }

    .life-form-item {
      height: 56px;
      background: #F8F8FA;
      border: 0.5px solid #E2E3E4;
      border-radius: 16px;
      padding: 0 18px 0 6px;
      margin-bottom: 15px;
      position: relative;
      display: flex;
      flex-direction: row;
      align-items: center;
      transition: all 0.3s ease; // 添加过渡效果
      box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05); // 添加微妙的阴影

      .select-text {
        width: 100%;
      	overflow: hidden;
      	white-space: nowrap;
      	text-overflow: ellipsis;
      	color: #c8c7ce;
        text-align: right;
        position: relative;
        padding-right: 20px; // 为下拉箭头留出空间
        cursor: pointer; // 添加手型光标
        user-select: none; // 防止文本被选中
        
        // 添加下拉箭头
        &::after {
          content: '';
          position: absolute;
          right: 0;
          top: 50%;
          transform: translateY(-50%);
          width: 0;
          height: 0;
          border-left: 4px solid transparent;
          border-right: 4px solid transparent;
          border-top: 6px solid #c8c7ce;
          transition: all 0.3s ease;
        }
        
      	&-act {
      		color: #686777;
      		
      		&::after {
      		  border-top-color: #686777;
      		}
      	}
      }

      // 添加悬停效果
      &:hover {
        background: #f0f0f2; // 轻微的背景色变化
        border-color: #d0d0d2; // 边框颜色变化
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1); // 悬停时阴影加深
        
        .select-text::after {
          border-top-color: #409EFF;
          transform: translateY(-50%) rotate(180deg);
        }
      }
      
      // 添加点击时的效果
      &:active {
        transform: scale(0.98);
        transition: transform 0.1s ease;
      }
      
      // 添加焦点状态
      &:focus-within {
        border-color: #409EFF;
        box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.2);
        
        .select-text::after {
          border-top-color: #409EFF;
        }
      }

      .form-item-select {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;

        /deep/ .el-select {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          z-index: 12;
          .el-input {
            width: 100%;
            height: 100%;
            .el-input__inner {
              width: 100%;
              height: 100%;
              opacity: 0;
            }
          }
        }
      }

      .form-item-title {
        font-family: Poppins;
        font-size: 16px;
        color: #686777;
        font-weight: 500;
        line-height: 24px;
      }

      .form-item-value {
        justify-content: flex-end;
        position: relative;
        z-index: 9;
        display: flex;
        flex: 1;
        width: 0;
        padding-left: 12px;

        input {
          width: 100%;
          font-size: 16px;
          color: #686777;
          height: 24px;
          font-weight: 500;
          text-align: right;
          padding-left: 5px;
        }

        // span {
        //   font-size: 16px;
        //   color: #ED3A42;
        // }

        .text-red {
        	font-size: 32rpx;
        	color: #ED3A42 !important;
        	display: block;
        }
      }

      &:last-child {
        margin-bottom: 0;
      }
    }
  }

  input {
    background: none;
    outline: none;
    border: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/life-form.vue